import { render, staticRenderFns } from "./requestAdditionalDialog.vue?vue&type=template&id=4aa68c36&scoped=true"
import script from "./requestAdditionalDialog.vue?vue&type=script&lang=js"
export * from "./requestAdditionalDialog.vue?vue&type=script&lang=js"
import style0 from "./requestAdditionalDialog.vue?vue&type=style&index=0&id=4aa68c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa68c36",
  null
  
)

export default component.exports